import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100dvh;
  background-color: #f0f0f5;
  display: flex;
  flex-direction: column;

  @media (min-width: 640px) {
    background-color: #3439a5;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    gap: 2.4rem;

    & > *:first-child {
      max-width: 200px;
      width: 100%;
    }
  }
`;
